import { defineStore } from 'pinia'
/**
 * @title 用于给APP框架增加状态管理器
 * @auth yzs
 */
export const useEchartStore = defineStore('echartStore', {
    state: () => ({
        options: {}
    }),
    actions: {
        setOptions(id, data) {
            this.options[id] = data
        }
    }
})